import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

const Navdata = () => {
  const history = useHistory();
  //state data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isTenantManagement, setIsTenantManagement] = useState(false);
  const [isSMSHistory, setIsSMSHistory] = useState(false);
  const [isOnBoarding, setIsOnBoarding] = useState(false);

  // Customers
  // const [isCustomers, setIsCustomers] = useState(false);

  // History Logs
  // const [isLogs, setIsLogs] = useState(false);
  const [isSettings, setIsSettings] = useState(false);

  // Pages
  // const [isProfile, setIsProfile] = useState(false);
  const [isLanding, setIsLanding] = useState(false);

  // Charts
  // const [isApex, setIsApex] = useState(false);

  // Multi Level
  // const [isLevel1, setIsLevel1] = useState(false);
  // const [isLevel2, setIsLevel2] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "TenantManagement") {
      setIsTenantManagement(false);
    }
    if (iscurrentState !== "SMSHistory") {
      setIsSMSHistory(false);
    }
    if (iscurrentState !== "OnBoarding") {
      setIsOnBoarding(false);
    }

    if (iscurrentState !== "Landing") {
      setIsLanding(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isTenantManagement,
    isSMSHistory,
    isOnBoarding,
    isLanding,
  ]);

  const menuItems = [
    {
      label: "nav.menu",
      isHeader: true,
    },
    {
      id: "dashboard",
      label: "nav.dashboard",
      icon: "ri-dashboard-line",
      link: "/dashboard",
      stateVariables: isDashboard,
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
    },
    {
      id: "sms-logs",
      label: "nav.smsLogs",
      icon: "ri-message-2-line",
      link: "/sms-logs",
      // All roles (HXSMSF-144); tenant users see only their own customer's
    },

    {
      label: "nav.management",
      isHeader: true,
      requiredRoles: ["SUPER_ADMIN", "ADMIN"],
    },
    {
      id: "tenant",
      label: "nav.tenant",
      icon: "ri-building-fill",
      link: "/customers",
      requiredRoles: ["SUPER_ADMIN", "ADMIN"],
    },
    {
      id: "system-tools",
      label: "nav.systemTools",
      icon: "ri-tools-line",
      link: "/system-tools",
      requiredRoles: ["SUPER_ADMIN", "ADMIN"],
    },

    {
      label: "nav.settings",
      isHeader: true,
    },
    {
      id: "integration",
      label: "nav.integration",
      icon: "ri-plug-line",
      link: "/integration",
      excludeRoles: ["SUPER_ADMIN", "ADMIN"],
      // Available to all tenant users (TENANT_ADMIN can connect/disconnect, TENANT_USER can only view)
    },
    {
      id: "plan-usage",
      label: "nav.planUsage",
      icon: "ri-bar-chart-2-line",
      link: "/plan-usage",
      excludeRoles: ["SUPER_ADMIN", "ADMIN"],
    },
    {
      id: "account",
      label: "nav.account",
      icon: "ri-key-2-fill",
      link: "/account",
    },
    {
      id: "team-1",
      label: "nav.team",
      icon: "ri-team-fill",
      link: "/team",
    },
    // {
    //   id: "billing",
    //   label: "Billing & Usage",
    //   icon: "ri-bill-line",
    //   link: "/#",
    //   stateVariables: isSettings,
    //   hideFromSuperAdmin: true, // Hide from SuperAdmin, show to others
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsSettings(!isSettings);
    //     setIscurrentState("Billing");
    //     updateIconSidebar(e);
    //   },
    //   subItems: [
    //     {
    //       id: "billing-overview",
    //       label: "Billing Overview",
    //       icon: "ri-dashboard-3-line",
    //       link: "/billing",
    //     },
    //     {
    //       id: "usage-metrics",
    //       label: "Usage Metrics",
    //       icon: "ri-line-chart-line",
    //       link: "/usage",
    //     },
    //     {
    //       id: "payment-methods",
    //       label: "Payment Methods",
    //       icon: "ri-bank-card-line",
    //       link: "/payment-methods",
    //     },
    //     {
    //       id: "invoices",
    //       label: "Invoices",
    //       icon: "ri-file-text-line",
    //       link: "/invoices",
    //     },
    //   ],
    // },

    {
      id: "help",
      label: "nav.userGuide",
      icon: "ri-book-open-line",
      link: "https://docs.hububble.co/home/hubspot-x-every8d",
      external: true,
    },

    // {
    //   id: "support",
    //   label: "Support Center",
    //   icon: "ri-customer-service-2-line",
    //   link: "/#",
    //   stateVariables: isSettings,
    //   // Available to all roles
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsSettings(!isSettings);
    //     setIscurrentState("Support");
    //     updateIconSidebar(e);
    //   },
    //   subItems: [
    //     {
    //       id: "contact-support",
    //       label: "Contact Support",
    //       icon: "ri-phone-line",
    //       link: "/contact-support",
    //     },
    //     {
    //       id: "documentation",
    //       label: "Documentation",
    //       icon: "ri-file-list-line",
    //       link: "/documentation",
    //     },
    //     {
    //       id: "faq",
    //       label: "FAQ",
    //       icon: "ri-question-answer-line",
    //       link: "/faq",
    //     },
    //     {
    //       id: "system-status",
    //       label: "System Status",
    //       icon: "ri-pulse-line",
    //       link: "/system-status",
    //       requiredRoles: ["SUPER_ADMIN", "ADMIN"], // Only admins need to see system status
    //     },
    //   ],
    // },
    {
      id: "logout",
      label: "nav.logout",
      icon: "ri-logout-box-r-line",
      link: "/logout-success",
      // Available to all roles
      click: function (e) {
        e.preventDefault();
        updateIconSidebar(e);
      },
    },
  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
